import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StepPreconditionService } from '../services/step-precondition.service';

/**
 * Route guard for the Payment step (step 3).
 *
 * Only allows access if both no_of_persons and no_of_recipes exist in session storage.
 * Otherwise redirects to intelligent fallback route.
 */
export const paymentGuard: CanActivateFn = () => {
  const stepPrecondition = inject(StepPreconditionService);
  const router = inject(Router);

  if (stepPrecondition.canAccessPayment()) {
    return true;
  }

  // Return UrlTree for redirect instead of side-effect navigation
  const fallbackRoute = stepPrecondition.getFallbackRoute();
  return router.createUrlTree([fallbackRoute]);
};
